export const isValidLatitudeDegree = (value: number): boolean =>
  isFinite(value) && Math.abs(value) <= 90;

export const isValidLongitudeDegree = (value: number): boolean =>
  isFinite(value) && Math.abs(value) <= 180;

/**
 * Represents geo-coordinate with a latitude and longitude in the Node API. Latitude is between -90 to 90 and longitude is -180 to 180
 */
export type CoordinatesType = [string, string];

// TODO: remove once legacy component dependency is refactored
/** @deprecated copied from legacy */
const stripToNumber = (value: string) => {
  const num = Number(value);

  if (isNaN(num)) {
    // if there are no numbers in the string at all, it's NaN
    return value.replace(/[^0-9.-]/g, "") === ""
      ? NaN
      : Number(value.replace(/[^0-9.-]/g, ""));
  }

  return num;
};

// TODO: remove once legacy component dependency is refactored
/** @deprecated copied from legacy. use isValidLatitudeDegree() instead */
export const isValidLatitude = (value: string) => {
  // 0 is a valid latitude
  if (value === null || typeof value === "undefined" || value === "") {
    return false;
  }

  const num = stripToNumber(value);
  return num === 0 || Math.abs(num) <= 90;
};

// TODO: remove once legacy component dependency is refactored
/** @deprecated copied from legacy. use isValidLongitudeDegree() instead */
export const isValidLongitude = (value: string) => {
  // 0 is a valid longitude
  if (value === null || typeof value === "undefined" || value === "") {
    return false;
  }

  const num = stripToNumber(value);
  return num === 0 || Math.abs(num) <= 180;
};

// TODO: remove once legacy component dependency is refactored
/** @deprecated copied from legacy. only for use in GeoPointInput component that needs a revamp. */
export const geoLocationValidator = (
  [lat, long]: CoordinatesType = ["", ""]
) => {
  const isValidLat = isValidLatitude(lat);
  const isValidLong = isValidLongitude(long);

  // create validation feedback
  // latitude
  const latValid = isValidLat ? "valid" : "invalid";
  const latMessage = `Latitude is ${latValid}`;
  // longitude
  const longValid = isValidLong ? "valid" : "invalid";
  const longMessage = ` and Longitude is ${longValid}`;
  // latitude + longitude
  const finalMessage = `${latMessage}${longMessage}`;

  return !isValidLat || !isValidLong ? finalMessage : undefined;
};
